import React from "react";
import t from "i18n";
import { formatAmount } from "../../../../services/utils";
import { CommonLoader } from "../../../common/CommonLoader";
import { isArray } from "lodash";

const PaperInscriptionsCASiloCompare = ({
  data1,
  data2,
  year,
  handleToggleKey,
  visibleKeys,
  silotDataFetch,
  startMonth,
  endMonth
}) => {

  const formatData = (data) => {
    const result = {};

    const filteredMonths = Object.keys(data).filter(monthKey => {
      const [, month] = monthKey.split("-"); // "2024-03" → "03"
      const m = parseInt(month, 10);
      return m >= parseInt(startMonth, 10) && m <= parseInt(endMonth, 10);
    });

    filteredMonths.forEach(monthKey => {
      const monthData = data[monthKey];
      Object.values(monthData).forEach(silot => {
        const { silotId, silotName, individuelNbrInscrit, individuelCa, fiduciareNbrInscrit, fiduciareCa, color } = silot;

        if (!result[silotId]) {
          result[silotId] = {
            silotId,
            silotName,
            totalNbrInscrit: 0,
            totalCa: 0,
            color,
          };
        }

        result[silotId].totalNbrInscrit += individuelNbrInscrit + fiduciareNbrInscrit;
        result[silotId].totalCa += individuelCa + fiduciareCa;
      });
    });

    return result;

  };
  const formattedData1 = formatData(data1);
  const formattedData2 = formatData(data2);

  console.log('==== formattedData1', formattedData1);
  console.log('==== formattedData2', formattedData2);

  const getGlobalTotals = (formattedData) => {
    return Object.values(formattedData).reduce(
      (acc, silot) => {
        acc.totalNbrInscrit += silot.totalNbrInscrit;
        acc.totalCa += silot.totalCa;
        return acc;
      },
      {
        totalNbrInscrit: 0,
        totalCa: 0,
      }
    );
  }

  const globalTotals1 = getGlobalTotals(formattedData1);
  const globalTotals2 = getGlobalTotals(formattedData2);
  // console.log('==== globalTotals', globalTotals);

  const totalNbr1 = globalTotals1.totalNbrInscrit;
  const totalCa1 = globalTotals1.totalCa;

  const totalNbr2 = globalTotals2.totalNbrInscrit;
  const totalCa2 = globalTotals2.totalCa;
  return (
    <div style={{ width: '60%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{
        background: "#F9FAFB",
        padding: "20px",
        borderRadius: "10px",
        width: "100%",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
      }}>
        {silotDataFetch ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
          (
            <React.Fragment>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  fontSize: "14px",
                  color: "#29394D",
                  borderBottom: "1px solid #D8DDE2",
                }}
              >
                <span style={{ width: "35%" }}></span>
                <span style={{ width: "30%", textAlign: "end", opacity: 0.7 }}>{year - 1}</span>
                <span style={{ width: "30%", textAlign: "end" }}>{year}</span>
                <span style={{ width: "5%" }}></span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  fontSize: "14px",
                  color: "#29394D",
                  borderBottom: "1px solid #D8DDE2",
                }}
              >
                <span style={{ width: "35%" }}></span>
                <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", opacity: 0.7 }}>
                  <span style={{ width: "50%", textAlign: "start" }}>Inscription</span>
                  <span style={{ width: "50%", textAlign: "end" }}>C.A</span>
                </span>
                <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", paddingLeft: "10px" }}>
                  <span style={{ width: "50%", textAlign: "start" }}>Inscription</span>
                  <span style={{ width: "50%", textAlign: "end" }}>C.A</span>
                </span>
                <span style={{ width: "5%" }}></span>
              </div>

              {Object.entries(formattedData1)
                .sort(([, a], [, b]) => b.totalNbrInscrit - a.totalNbrInscrit)
                .map(([silotId, silot1]) => {

                  const { silotName, totalNbrInscrit, totalCa, color } = silot1;
                  const silot2 = formattedData2[silotId] || { totalNbrInscrit: 0, totalCa: 0 };
                  const { silotName: silotName2, totalNbrInscrit: totalNbrInscrit2, totalCa: totalCa2 } = silot2;


                  return (
                    <React.Fragment key={silotId}>
                      <div style={{ padding: "10px 0", opacity: visibleKeys.includes(Number(silotId)) ? 1 : 0.5, borderBottom: "1px solid #D8DDE2", }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "23%" }} >
                            <span style={{ width: "8px", height: "8px", borderRadius: "40%", backgroundColor: color }} ></span>
                            <span style={{ fontWeight: "500", fontSize: "16px", color: "#29394D", textTransform: "capitalize" }}>
                              {silotName}
                            </span>
                          </div>
                          {
                            (parseFloat(((((totalCa) - (totalCa2)) / (totalCa2)) * 100).toFixed(2))) > 0
                              ?
                              <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                                <img src="/img/icons/manage-BM/BM_plus.svg" />
                                <span className={'ml-1'} style={{ color: '#02af8e' }}>{Math.abs(parseFloat(((((totalCa) - (totalCa2)) / (totalCa2 == 0 ? totalCa : totalCa2)) * 100).toFixed(2)))}%</span>
                              </div>
                              :
                              (parseFloat(((((totalCa) - (totalCa2)) / (totalCa2)) * 100).toFixed(2))) < 0
                                ?
                                <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                                  <img src="/img/icons/manage-BM/BM_moins.svg" />
                                  <span className={'ml-1'} style={{ color: '#fe3745' }}>{Math.abs(parseFloat(((((totalCa) - (totalCa2)) / (totalCa2 == 0 ? totalCa : totalCa2)) * 100).toFixed(2)))}%</span>
                                </div>
                                :
                                <div style={{ width: '12%' }} />
                          }
                          <span style={{ fontWeight: "500", color: color, width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", opacity: 0.7 }} >
                            <span style={{ width: "50%", textAlign: "start" }} >{totalNbrInscrit2}</span>
                            <span style={{ width: "50%", textAlign: "end" }} >{formatAmount(totalCa2)}</span>
                          </span>
                          <span style={{ fontWeight: "500", color: color, width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", paddingLeft: "10px" }} >
                            <span style={{ width: "50%", textAlign: "start" }} >{totalNbrInscrit}</span>
                            <span style={{ width: "50%", textAlign: "end" }} >{formatAmount(totalCa)}</span>
                          </span>
                          <span
                            style={{ width: "5%", display: "flex", justifyContent: "center", cursor: "pointer" }}
                            onClick={() => handleToggleKey(Number(silotId))}
                          >
                            <img src={visibleKeys.includes(Number(silotId)) ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt="" />
                          </span>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}

              <div
                style={{
                  borderTop: "1px solid #29394D",
                  marginTop: "25px",
                  paddingTop: "12px",
                  fontWeight: "700",
                  color: "#29394D",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "16px",
                }}
              >
                <span style={{ width: "23%" }}>Total</span>
                {
                  (parseFloat(((((totalCa1) - (totalCa2)) / (totalCa2)) * 100).toFixed(2))) > 0
                    ?
                    <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                      <img src="/img/icons/manage-BM/BM_plus.svg" />
                      <span className={'ml-1'} style={{ color: '#02af8e' }}>{Math.abs(parseFloat(((((totalCa1) - (totalCa2)) / (totalCa2 == 0 ? totalCa1 : totalCa2)) * 100).toFixed(2)))}%</span>
                    </div>
                    :
                    (parseFloat(((((totalCa1) - (totalCa2)) / (totalCa2)) * 100).toFixed(2))) < 0
                      ?
                      <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                        <img src="/img/icons/manage-BM/BM_moins.svg" />
                        <span className={'ml-1'} style={{ color: '#fe3745' }}>{Math.abs(parseFloat(((((totalCa1) - (totalCa2)) / (totalCa2 == 0 ? totalCa1 : totalCa2)) * 100).toFixed(2)))}%</span>
                      </div>
                      :
                      <div style={{ width: '12%' }} />
                }
                <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", opacity: 0.7 }}>
                  <span style={{ width: "50%", textAlign: "start" }}>{totalNbr2}</span>
                  <span style={{ width: "50%", textAlign: "end" }}>{formatAmount(totalCa2)}</span>
                </span>
                <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", paddingLeft: "10px" }}>
                  <span style={{ width: "50%", textAlign: "start" }}>{totalNbr1}</span>
                  <span style={{ width: "50%", textAlign: "end" }}>{formatAmount(totalCa1)}</span>
                </span>
                <span style={{ width: "5%" }}></span>
              </div>
            </React.Fragment>
          )}
      </div>
    </div>
  );
}

export default PaperInscriptionsCASiloCompare;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperInscriptionsCASiloCompare.js